/**
 * A session's comment wears the session's mark as its face (RFC 0311 S4).
 *
 * `projectAuthor` already names a session's comment by its title; this gives
 * it the same mark the session row draws, as the photo a person would have.
 * The comment elements are stringified into sandboxed frames and cannot call
 * `sessionAvatar` themselves, so the face travels as a data URI.
 */

import type { CommentAuthor } from '@mod/core/model'
import { sessionAvatar } from './sessionAvatar'

/** Built once per session: a list call draws the same few faces many times. */
const faces = new Map<string, string>()

function faceUrl(sessionId: string): string {
  let url = faces.get(sessionId)
  if (!url) {
    url = `data:image/svg+xml;utf8,${encodeURIComponent(sessionAvatar(sessionId, 32))}`
    faces.set(sessionId, url)
  }
  return url
}

export function sessionFace<A extends CommentAuthor>(author: A): A {
  if (author.kind !== 'agent' || !author.sessionId || author.avatarUrl) {
    return author
  }
  return { ...author, avatarUrl: faceUrl(author.sessionId) }
}
